import { UiDiscussionPage } from "../types/ui-discussion-page";
import { CohortActions } from "../types/cohort-actions";

export function uiDiscussionPage(state: UiDiscussionPage={ cohorts: [] }, action: CohortActions ): UiDiscussionPage {
    switch(action.type) {
        case 'cohorts/fetch-list-request':
            return { ...state, fetching: true, error: undefined };

        case 'cohorts/fetch-list-success':
            return { ...action.data, fetching: false };

        case 'cohorts/fetch-list-error':
            return { ...state, fetching: false, error: 'Connection Error' };

        case 'cohorts/change-request':
            return { fetching: true, error: undefined, multi_cohort: state.multi_cohort, cohorts: state.cohorts };

        case 'cohorts/change-success':
            return { ...action.data, fetching: false, multi_cohort: state.multi_cohort, cohorts: state.cohorts };

        case 'cohorts/change-error':
            return { ...state, fetching: false, error: 'Connection Error' };
        
        default:
            return state;
    }
}